import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZ4mixA: IAbstractModule = {
    type: IModuleType.Z4comp,
    name: 'Z 4 mix A',
    hasScreen: false,
    columns: [
        [
            {
                name: "1",
                connector: "1",
                cell_size_id: 1,
                accessible: false,
            },
            {
                name: "2",
                connector: "2",
                cell_size_id: 1,
                accessible: false,
            }
        ],
        [
            {
                name: "1",
                connector: "3",
                cell_size_id: 1,
                accessible: false,
            },
            {
                name: "2",
                connector: "4",
                cell_size_id: 1,
                accessible: false,
            }
        ],
    ]
};
